import axios from 'axios';
export const API_URL = process.env.REACT_APP_BACKEND_URL || 'http://localhost:8000';

const api = axios.create({
  baseURL: API_URL,
});

export const setHeaders = (token) => ({ Authorization: "Bearer " + token });
export default api;